<template lang="html">
  <div id="service-page">

    <section class="main-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-banner">
            <div class="image">
              <div class="placed-backg img-fake" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/banner-5.jpg)' }"></div>
              <img src="public/images/pages/services/banner-proyectos-ingenieria.jpg">
            </div>
          </div>

          <div class="col-lg-12 col-content">
            <!-- <div class="box-float-image f-l" style="width: 423px;">
              <img src="public/images/pages/services/proyectos-e-ingenieria.jpg">
            </div> -->

            <h5 class="title">Proyectos e ingenieria</h5>

            <p>
              Procesos Plásticos Inyectados S.A de C.V da soluciones a sus problemas en plástico, desarrollando sus productos partiendo desde una idea, diseñando las piezas y los moldes conjuntamente para una mayor optimización de costes y calidad en todo el proceso hasta obtener el producto que usted tiene en mente.
            </p>

            <br />
            <p>
              Ponemos en marcha cualquier proyecto, tanto de diseño y desarrollo de piezas plásticas como de las herramientas para su fabricación en serie; podemos partir desde modelos conceptuales hasta bosquejos pasando por croquis o muestras físicas. El objetivo es minimizar los problemas en las piezas, acortar el tiempo total de desarrollo y aumentar el rendimiento del molde.
            </p>

            <br />
            <p>
              También elaboramos modelos computacionales (render o fotorealísticos) así como prototipos físicos.
            </p>

            <br />
            <p>
              El objetivo de procesos plásticos inyectados es el de satisfacer y acompañar a sus clientes en el diseño de nuevas piezas plásticas.
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
